<p-dialog [(visible)]="isVisible" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
    styleClass="dropbox-modal-dialog" (onHide)="onModalHide()">

    <!-- Custom Header Template -->
    <ng-template pTemplate="header">
        <div class="modal-header">
            <h5 class="modal-title" id="dropboxModalLabel">
                <img src="assets/img/dropbox.png" alt="Dropbox" width="48" height="40">
                Select File from Dropbox
            </h5>
        </div>
    </ng-template>

    <div class="dropbox-modal-content">

        <!-- Loading State -->
        <div *ngIf="isLoading" class="loading-container">
            <div class="loading-content">
                <i class="pi pi-spin pi-spinner loading-spinner"></i>
                <p class="loading-message">Connecting to Dropbox...</p>
            </div>
        </div>

        <!-- Main Content -->
        <div *ngIf="!isLoading && !error" class="modal-body">

            <!-- Dropbox Info -->
            <div class="info-section">
                <div class="service-header">
                    <img src="assets/img/dropbox.png" alt="Dropbox" class="service-icon">
                    <div class="service-info">
                        <h6 class="service-title">Dropbox</h6>
                        <p class="service-description">Connect to Dropbox</p>
                        <p class="service-description">Sign in to access your files from Dropbox</p>
                    </div>
                </div>
            </div>

            <!-- File Type Info -->
            <div class="file-info-section">
                <div class="supported-formats">
                    <!-- <small class="format-label">Supported formats:</small> -->
                    <small class="format-label">Supported format:</small>
                    <div class="format-badges">
                        <span class="format-badge">PDF</span>
                        <!-- <span class="format-badge">DOC</span>
            <span class="format-badge">DOCX</span> -->
                    </div>
                </div>
                <div class="size-limit">
                    <small class="size-label">Maximum file size: <strong>10 MB</strong></small>
                </div>
            </div>

            <!-- Instructions -->
            <div class="instructions-section">
                <div class="instruction-item">
                    <i class="pi pi-check-circle instruction-icon"></i>
                    <span>Click "Browse Dropbox Files" to authenticate</span>
                </div>
                <div class="instruction-item">
                    <i class="pi pi-check-circle instruction-icon"></i>
                    <span>Browse and select your PDF document</span>
                </div>
                <!-- <div class="instruction-item">
    <i class="pi pi-check-circle instruction-icon"></i>
    <span>Select your PDF or document file</span>
  </div> -->
                <div class="instruction-item">
                    <i class="pi pi-check-circle instruction-icon"></i>
                    <span>Click the "Choose" button</span>
                </div>
            </div>

            <!-- Loading Integration Status -->
            <div *ngIf="!isDropboxLoaded" class="integration-status">
                <div class="status-message">
                    <i class="pi pi-spin pi-spinner status-icon"></i>
                    <span>Loading Dropbox integration...</span>
                </div>
            </div>

        </div>

        <!-- Error Display -->
        <div *ngIf="error && !isLoading" class="error-section">
            <div class="error-message">
                <i class="pi pi-exclamation-triangle error-icon"></i>
                <span>{{ error }}</span>
            </div>
        </div>

    </div>

    <!-- Footer -->
    <ng-template pTemplate="footer">
        <div class="modal-footer" style="border-top: 1px solid #e1e5e9;padding-top: 1rem;">
            <p-button label="Cancel" icon="pi pi-times" (onClick)="closeModal()" [disabled]="isLoading"
                styleClass="p-button-text">
            </p-button>

            <p-button label="Browse Dropbox Files" icon="pi pi-folder-open" (onClick)="openDropboxChooser()"
                [loading]="isLoading" [disabled]="isLoading || !isDropboxLoaded" styleClass="p-button-primary">
            </p-button>
        </div>
    </ng-template>

</p-dialog>

<!-- Global Loading Overlay -->
<div *ngIf="isLoading" class="global-loading-overlay">
    <div class="loading-backdrop"></div>
</div>